<div class="page-container">
  @if(pageStatus === pageStatusEnum.LOADING) {
    <app-loading text="Carregando cardápio..."></app-loading>
  } @else if(pageStatus === pageStatusEnum.SUCCESS) {
    <app-bar
      title="Cardápio"
      [backButtonProps]="backButtonProps"
      (backButtonClick)="handleBackButtonClick()"
      [actionButtonProps]="isTabletLandscape ? callWaiterButtonProps : null"
      (actionButtonClick)="handleCallWaiter()"
    ></app-bar>

    <div class="page-content" [ngClass]="{'floating-footer-fix': cart && cart.length > 0}">
      @if(featuredItems.length > 0) {
        <app-featured-items
          [items]="featuredItems"
          (itemClick)="openProductModal($event)"
        ></app-featured-items>
      }

      <nav class="page-navigation">
        <ul>
          <li *ngFor="let category of storeMenuCategories">
            <a
              class="label-medium-medium"
              [class.active]="activeCategoryId === category.id"
              (click)="scrollToCategory(category.id)"
            >
              {{ category.name }}
            </a>
          </li>
        </ul>
      </nav>

      <section
        class="category-items-container"
        *ngFor="let category of storeMenuCategories"
      >
        <div [id]="'product-category-' + category.id.toString()" class="w-100">
          <h2 class="label-semibold-large">
            {{ category.name }}
          </h2>

          <ng-container *ngFor="let product of category.items" class="w-100">
            <app-product-list-item
              [productItem]="product"
              (itemClick)="openProductModal(product)"
            ></app-product-list-item>
          </ng-container>
        </div>
      </section>
    </div>

    @if(cart && cart.length > 0) {
      <div class="page-footer page-footer-floating-bottom">
        <div class="d-flex space-between align-center">
          <div class="total-container">
            <h3 class="label-regular-tiny">
              Total do pedido:
            </h3>
            <div class="total-value">
              <span class="label-semibold-large">
                {{ cartTotal | currency }}
              </span>
              <span class="separator-dot"></span>
              <small class="label-regular-tiny">
                {{ qtyItemsAddedToCart }} itens
              </small>
            </div>
          </div>
          <mnt-button
            [label]="'Ver pedido'"
            icon-left="shoppingBag"
            size="medium"
            color="primary"
            variant="emphasis"
            (buttonClick)="navigateToCart()"
          ></mnt-button>
        </div>
      </div>

      <aside class="menu-cart-panel">
        <div class="menu-cart-header">
          <h3 class="title-large">Seu pedido</h3>
          <span class="label-regular-small text-color-subtitle">{{ qtyItemsAddedToCart }} itens</span>
        </div>

        <div class="menu-cart-items">
          <div class="menu-cart-item" *ngFor="let item of displayCart">
            <div class="menu-cart-item-image" [ngClass]="{ 'neutral-background': !item.img }">
              <img
                *ngIf="item.img"
                [src]="item.img"
                [alt]="item.name"
              />
              <mnt-icon
                *ngIf="!item.img"
                icon="image"
                color="#4B5053"
                [background]="['#E5E7E8', 'rounded']"
                size="medium"
              ></mnt-icon>
            </div>

            <div class="menu-cart-item-info">
              <span class="label-medium-small">{{ item.name }}</span>

              <ul class="unstyled-list" *ngIf="item.selectedChoices && item.selectedChoices.length > 0">
                <li *ngFor="let choice of item.selectedChoices">
                  <span class="label-regular-tiny text-color-subtitle">
                    {{ choice.quantity || 1 }}x {{ choice.name }}
                  </span>
                </li>
              </ul>

              <span class="label-regular-small text-color-subtitle" *ngIf="item.additional_info">
                Obs: {{ item.additional_info }}
              </span>

              <span class="label-medium-small">{{ item.total * item.qty | currency }}</span>
            </div>

            <div class="menu-cart-item-qty">
              <mnt-field-number
                variant="plain"
                size="small"
                [max]="99"
                [min]="0"
                [value]="item.qty"
                (change)="handleQuantityChange(item, $event)"
              ></mnt-field-number>
            </div>
          </div>
        </div>

        <div class="menu-cart-footer">
          <div class="menu-cart-total">
            <span class="label-regular-small text-color-subtitle">Total do pedido</span>
            <span class="label-semibold-large">{{ cartTotal | currency }}</span>
          </div>
          @if(!submittingOrder) {
            <mnt-button
              [label]="'Fazer pedido'"
              icon-left="shoppingBag"
              size="large"
              color="primary"
              variant="emphasis"
              full-width
              (buttonClick)="handleSubmitOrder()"
            ></mnt-button>
          } @else {
            <mnt-button
              label="Enviando pedido..."
              icon-left="loading"
              animation="spin"
              size="large"
              color="primary"
              variant="emphasis"
              full-width
              disabled
            ></mnt-button>
          }
        </div>
      </aside>
    }
  }
</div>

<!--
    <div class="page-content" [ngClass]="{'floating-footer-fix': cart && cart.length > 0}">
      <nav class="page-navigation">
        <ul>
          <li *ngFor="let category of storeMenuCategories">
            <a
              class="label-medium-medium"
              [class.active]="activeCategoryId === category.id"
              (click)="scrollToCategory(category.id)"
            >
              {{ category.name }}
            </a>
          </li>
        </ul>
      </nav>

      <section
        class="category-items-container"
        *ngFor="let category of storeMenuCategories"
      >
        <div [id]="'product-category-' + category.id.toString()" class="w-100">
          <h2 class="label-semibold-large">
            {{ category.name }}
          </h2>

          <ng-container *ngFor="let product of category.items" class="w-100">
            <app-product-list-item
              [productItem]="product"
              (itemClick)="openProductModal(product)"
            ></app-product-list-item>
          </ng-container>
        </div>
      </section>
    </div> -->